import theme from 'common/theme'
import styled from 'styled-components'

const BadgeStyleByVariant = (
  variant: string,
  backgroundColor: string,
  width: string,
  height: string,
  borderRadius: string,
  fontSize: string,
): string => {
  let style = ''

  switch (variant) {
    case 'alt1':
      style = `
        background: ${
          backgroundColor ||
          'linear-gradient(to right, #ed1a34 33%, #ff5000 147%)'
        };
        min-width: ${width || '75px'};
        min-height:  ${height || '25px'}; 
        line-height: ${height || '25px'};
        border-radius: ${borderRadius || '15px'};
        font-size: ${fontSize || '12px'};
        `
      break

    default:
      style = `
        background: ${backgroundColor || theme.colors.orange};
        min-width: ${width || '22px'};
        min-height:  ${height || '22px'}; 
        line-height: ${height || '22px'};
        border-radius: ${borderRadius || '50%'};
        font-size: ${fontSize || '11px'};`
      break
  }

  return style
}

const StyledBadge = styled.div`
  font-weight: ${({ fontWeight }) => fontWeight || 'bold'};
  text-align: center;
  white-space: nowrap;
  top: ${({ top }) => top || ''};
  right: ${({ right }) => right || ''};
  position: ${({ position }) => position || 'absolute'};
  color: ${({ fontColor }) => fontColor || theme.colors.white};
  border: ${({ border }) => border || ''};
  padding: ${({ padding }) => padding || ''};
  display: ${({ display }) => display || 'block'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};

  ${(props) =>
    BadgeStyleByVariant(
      props.variant,
      props.backgroundColor,
      props.width,
      props.height,
      props.borderRadius,
      props.fontSize,
    )};
`

const ContentWrapper = styled.div`
  margin: 0 5px 0 5px;
`

interface BadgeType {
  content?: string | number | JSX.Element
  variant?: string
  backgroundColor?: string
  top?: string
  right?: string
  width?: string
  height?: string
  fontColor?: string
  borderRadius?: string
  position?: string
  fontSize?: string
  border?: string
  fontWeight?: string
  padding?: string
  display?: string
  alignItems?: string
}

function Badge({
  variant,
  content,
  backgroundColor,
  fontColor,
  top,
  right,
  width,
  height,
  borderRadius,
  position,
  fontSize,
  border,
  fontWeight,
  padding,
  display,
  alignItems,
  ...props
}: BadgeType): JSX.Element {
  return (
    <StyledBadge
      backgroundColor={backgroundColor}
      variant={variant}
      top={top}
      right={right}
      width={width}
      height={height}
      fontColor={fontColor}
      borderRadius={borderRadius}
      position={position}
      fontSize={fontSize}
      border={border}
      fontWeight={fontWeight}
      padding={padding}
      display={display}
      alignItems={alignItems}
      {...props}
    >
      <ContentWrapper>{content}</ContentWrapper>
    </StyledBadge>
  )
}

export default Badge
